import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ProtectedRoute } from '@/auth/ProtectedRoute';
import { Layout } from '@/components/Layout';
import { Overview } from '@/pages/Overview';
import { LoanInfo } from '@/pages/LoanInfo';
import { OppTop } from '@/pages/OppTop';
import { OppSpreadPairs } from '@/pages/OppSpreadPairs';
import { OppFundingHedge } from '@/pages/OppFundingHedge';
import { OppShort1Long2MidDeviation } from '@/pages/OppShort1Long2MidDeviation/OppShort1Long2MidDeviation';
import { KlineScreener } from '@/pages/KlineScreener';
import { RealtimeSpread } from '@/pages/RealtimeSpread';
import { OppSpreadLive } from '@/pages/OppSpreadLive';
import { Login } from '@/pages/Login/Login';
import { Register } from '@/pages/Register';
import { Landing } from '@/pages/Landing';
import { TradingSettings } from '@/pages/TradingSettings';
import { SystemApiKeys } from '@/pages/SystemApiKeys';
import { AccountOverview } from '@/pages/AccountOverview';
import { Instructions } from '@/pages/Instructions';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/landing" element={<Navigate to="/" replace />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route path="overview" element={<Navigate to="/detail-static" replace />} />
          <Route path="detail-static" element={<Overview />} />
          <Route path="loan-info" element={<LoanInfo />} />
          <Route path="account-overview" element={<AccountOverview />} />
          <Route path="instructions" element={<Instructions />} />
          <Route path="position-group-history" element={<Navigate to="/account-overview?tab=orders" replace />} />
          <Route path="market" element={<OppTop />} />
          <Route path="opp" element={<Navigate to="/market" replace />} />
          <Route path="opp-pairs" element={<OppSpreadPairs />} />
          <Route path="opp-funding-hedge" element={<OppFundingHedge />} />
          <Route path="opp-funding-upcoming" element={<Navigate to="/opp-funding-hedge" replace />} />
          <Route path="opp-mid-deviation" element={<OppShort1Long2MidDeviation />} />
          <Route path="kline-screener" element={<KlineScreener />} />
          <Route path="realtime-spread" element={<RealtimeSpread />} />
          <Route path="trading" element={<OppSpreadLive />} />
          <Route path="opp-spread-live" element={<Navigate to="/trading" replace />} />
          <Route path="trading-settings" element={<TradingSettings />} />
          <Route path="system-api-keys" element={<SystemApiKeys />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
